
import useActivitiesListQuery, { CurrentPaginationParams } from '../queries/useActivitiesList.query';

const useActivitiesList = ({
  page,
  perPage,
  searchString,
  accountId,
  types,
  startDate,
  endDate,
  hasActiveHold,
}: CurrentPaginationParams) => {
  const { total, isLoading, data, refetch } = useActivitiesListQuery({
    page,
    perPage,
    searchString,
    accountId,
    types,
    startDate,
    endDate,
    hasActiveHold,
  });

  return ({
    data,
    isLoading,
    total,
    refetch,
  });
};

export default useActivitiesList;
